import { useState, useEffect, forwardRef } from "react";
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PO_STATUS } from "../../constants/commonConstants";

const POStatusAutocomplete = forwardRef((props,ref) => {
    const {allOption=false, selectedValues=[], isFormikFormField = false, showFormError = false, 
        isCompulsory=false, singleSelect=true, label="PO Status", searchPlaceholder="Search By PO Status",
        noDataLabel="No PO Status Found", width = '100%', listWidth = width,
        ...rest} = props;
    const poStatusOptions = PO_STATUS;
    if(allOption && singleSelect){
        poStatusOptions.unshift({label:'All', id:-1})
    }
    let initialProps = {
        ...rest,
        labelKey:'label',
        primaryKey:'id',
        options:poStatusOptions,
        isObject:true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        dataLoaded: selectedValues.length > 0 ? false : true
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);

    useEffect(() => {
        if(selectedValues.length > 0){
            let preSelectedValues = [];
            if(selectedValues.length > 0){
                preSelectedValues =  poStatusOptions.filter((vc) => selectedValues.indexOf(vc.id) >= 0);
                const newProps = {...defaultProps, preSelectedValues, dataLoaded:true}
                setDefaultProps(newProps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedValues]);
    return ( defaultProps.dataLoaded ?
        !isFormikFormField ? 
        <MultiSelectDropDown
            ref={ref}
            {...defaultProps}
        /> :
        <MultiSelectDropDownForm
            ref={ref}
            {...defaultProps}
        /> : <></>
    );
});

export default POStatusAutocomplete;